import { useContext } from 'react';

import { GlobalContext } from "../../../contexts/globalContext"
import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { AddConferenceContext } from "../../../contexts/addConferenceContext"

import styles from './ConferenceDetailsComponent.module.css'

import HeaderComponent from '../../commons/HeaderComponent';
import PopupBaseComponent from '../common/PopupBaseComponent';
import DateTimeDetailsComponent from './DateTimeDetailsComponent';
import QuickPresentationAddComponent from './QuickPresentationAddComponent';
import ParticipantsDetailsConferenceComponent from './ParticipantsDetailsConferenceComponent';
import TopicsDetailsConferenceComponents from './TopicsDetailsConferenceComponents';
import ConferenceAddNewTopicComponent from './ConferenceAddNewTopicComponent';
import FilesDetailsConferenceDetailsComponent from './FilesDetailsConferenceDetailsComponent';
import ConferenceAddFilesComponent from './ConferenceAddFilesComponent';
import ManageParticipantsComponent from '../conferenceManageParticipants/ManageParticipantsComponent';
import DeleteNotificationComponent from '../common/DeleteNotificationComponent';
import AddModeratorPopup from './AddModeratorPopup';
import NewConferenceAddComponent from '../NewConferenceAddComponent';
import NewMeetingAddComponent from '../NewMeetingAddComponent';

import video from '../../../graphics/big wave fundal loop_6.mp4'


const ConferenceDetailsComponent = () => {
    
    const { appHeight, appWidth } = useContext(GlobalContext)
    const { editConference } = useContext(ProjectDetailsContext)
    const { addNewTopic, seeDateTime, openFiles, conferenceAddFiles, openParticipants, deleteClicked, setDeleteClicked, addModerator } = useContext(AddConferenceContext)

    return (
        <PopupBaseComponent width='100%' marginLeft='0px'
            style={{ height: `${appHeight}px`, width: '100%', marginLeft: 0 }} flexDirection='column'>
            <video id="background-video" autoPlay loop playsInline muted style={{ height: `${appHeight}px`, width: '100%' }}>
                <source src={video} type="video/mp4" />
            </video>
            <HeaderComponent />
            <div className={styles.body}>
                <div className={styles.column} style={{ width: (appWidth - 240) * 0.33 }}>
                    {editConference.type !== 'Presentation' &&
                        <DateTimeDetailsComponent />
                    }
                    <ParticipantsDetailsConferenceComponent />
                    {editConference.type === 'Presentation' &&
                        <QuickPresentationAddComponent />
                    }
                </div>
                {editConference.type !== "Meeting" && <div className={styles.column} style={{ width: (appWidth - 240) * 0.405 }}>
                    <TopicsDetailsConferenceComponents />
                </div>}
                <div className={styles.column} style={{ width: (appWidth - 240) * 0.245 }}>
                    {openFiles && editConference.topics.length > 0 && <FilesDetailsConferenceDetailsComponent />}
                </div>
            </div>
            {addNewTopic && <ConferenceAddNewTopicComponent />}

            {seeDateTime && editConference.type === "Conference" && <NewConferenceAddComponent />}
            {seeDateTime && editConference.type === "Meeting" && <NewMeetingAddComponent />}

            {conferenceAddFiles && <ConferenceAddFilesComponent />}
            {openParticipants && <ManageParticipantsComponent />}
            {deleteClicked?.shown === true && <DeleteNotificationComponent deleteClicked={deleteClicked} setDeleteClicked={setDeleteClicked} />}
            {addModerator && !addNewTopic && <AddModeratorPopup />}

        </PopupBaseComponent>
    );

}

export default ConferenceDetailsComponent;